export const layout = {
	state: {
		showLeftDrawer: true,
		showRightDrawer: false,
		projectsPageViewMode: 1,
		videoPlayerModal: {
			show: false,
			languageCode: '',
			language: '',
			project: {},
			posterMode: false
		},
		interactiveModal: {
			show: false,
			languageCode: '',
			language: '',
			project: {},
			posterMode: false
		},
		showTerminalContent: false,
		copilotIsInstalled: false
	},
	mutations: {
		setLeftDrawerState(state, status) {
			state.showLeftDrawer = status;
		},
		setRightDrawerState(state, status) {
			state.showRightDrawer = status;
		},
		setTerminalContentState(state, status) {
			state.showTerminalContent = status;
		},
		setProjectsPageViewMode(state, status) {
			state.projectsPageViewMode = status;
		},
		setVideoPlayerModal(state, status) {
			// console.log('IN STORE', status);
			state.videoPlayerModal.project = status.project;
			state.videoPlayerModal.languageCode = status.languageCode;
			state.videoPlayerModal.language = status.language;
			state.videoPlayerModal.show = true;
			state.videoPlayerModal.posterMode = status.posterMode;
			// state.videoPlayerModal = status;
		},
		setInteractiveModal(state, status) {
			state.interactiveModal.project = status.project;
			state.interactiveModal.languageCode = status.languageCode;
			state.interactiveModal.language = status.language;
			state.interactiveModal.show = true;
			state.interactiveModal.posterMode = status.posterMode;
			// state.interactiveModal = status;
		},
		setCopilotIsInstalled(state, status) {
			state.copilotIsInstalled = status;
		}
	},
	getters: {
		getLeftDrawerState(state) {
			return state.showLeftDrawer;
		},
		getRightDrawerState(state) {
			return state.showRightDrawer;
		},
		getTerminalContentState(state) {
			return state.showTerminalContent;
		},
		getProjectsPageViewMode(state) {
			return state.projectsPageViewMode;
		},
		getVideoPlayerModal(state) {
			return state.videoPlayerModal;
		},
		getInteractiveModal(state) {
			return state.interactiveModal;
		},
		getCopilotIsInstalled(state) {
			return state.copilotIsInstalled;
		}
	},
	actions: {
		setLeftDrawerState({ commit }, status) {
			commit('setLeftDrawerState', status);
		},
		setRightDrawerState({ commit }, status) {
			commit('setRightDrawerState', status);
		},
		setTerminalContentState({ commit }, status) {
			commit('setTerminalContentState', status);
		},
		setProjectsPageViewMode({ commit }, status) {
			commit('setProjectsPageViewMode', status);
		},
		setVideoPlayerModal({ commit }, status) {
			commit('setVideoPlayerModal', status);
		},
		setInteractiveModal({ commit }, status) {
			commit('setInteractiveModal', status);
		},
		setCopilotIsInstalled({ commit }, status) {
			commit('setCopilotIsInstalled', status);
		}
	}
};
